export function getStatusClass(status: string): string {
  switch (status) {
    case "success":
      return "text-success";
    case "authorized":
      return "text-warning";
    case "pending":
      return "text-warning";
    case "cancelled":
      return "text-accent";
    case "canceled":
      return "text-accent";
    case "sent":
      return "text-warning";
    case "expired":
      return "text-error";
    case "failed":
      return "text-error";
    default:
      return "text-warning";
  }
}
